function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import InfoBox, { InfoBoxType } from '../info-box/InfoBox';
import { ICON_CHECK_CIRCLE } from '../../icons';
export const SuccessBox = props => /*#__PURE__*/React.createElement(InfoBox, _extends({}, props, {
  type: InfoBoxType.SUCCESS
}));
SuccessBox.defaultProps = {
  icon: ICON_CHECK_CIRCLE,
  dataRef: 'success-box'
};
export default SuccessBox;
//# sourceMappingURL=SuccessBox.js.map